var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioAndVideoCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 327,
    height: 297,
    fill: "none",
    viewBox: "0 0 327 297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M31.488 269.674c-2.988 9.983 1.65 20.189 1.65 20.189s9.483-5.979 12.471-15.961c2.989-9.983-1.65-20.189-1.65-20.189s-9.483 5.979-12.471 15.961Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M36.024 269.943c2.515 10.112-2.598 20.089-2.598 20.089s-9.192-6.419-11.707-16.531c-2.515-10.112 2.598-20.089 2.598-20.089s9.192 6.419 11.707 16.531Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB8B8",
    d: "m185.497 279.985 1.902-4.893-17.967-9.666-2.807 7.221 18.872 7.338Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M195.687 267.22a6.58 6.58 0 0 0-7.147 1.585 6.565 6.565 0 0 0-1.381 2.169l-1.283 3.298-1.978 5.091-.484 1.249 6.34 2.466 6.132-15.779-.199-.079Zm-11.789 3.348-.827 2.194-2.065 5.476-.05.137c-5.26.676-11.027-.649-16.361-2.708a66.608 66.608 0 0 1-6.262-2.794 91.043 91.043 0 0 1-7.871-4.509c-3.244-2.082-5.25-3.645-5.25-3.645s-.53.479-1.489 1.3a163.165 163.165 0 0 1-5.94 4.838c-.993.777-2.058 1.589-3.197 2.437-8.393 6.226-19.164-10.386-19.164-10.386s3.029-1.929 3.821-2.303c2.548-1.206 8.535-4.051 13.699-6.579 2.661-1.305 5.101-2.528 6.739-3.397 5.8-3.088 13.011 2.756 13.011 2.756l31.206 17.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m183.898 270.568-.827 2.194-2.065 5.476-.05.137c-5.26.676-11.027-.649-16.361-2.708a66.608 66.608 0 0 1-6.262-2.794 91.043 91.043 0 0 1-7.871-4.509c-3.244-2.082-5.25-3.645-5.25-3.645s-.53.479-1.489 1.3a163.165 163.165 0 0 1-5.94 4.838c-.993.777-2.058 1.589-3.197 2.437-8.393 6.226-19.164-10.386-19.164-10.386s3.029-1.929 3.821-2.303c2.548-1.206 8.535-4.051 13.699-6.579 2.661-1.305 5.101-2.528 6.739-3.397 5.8-3.088 13.011 2.756 13.011 2.756l31.206 17.183Z",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "M77.612 154.097c40.749 0 73.783-33.035 73.783-73.784 0-40.75-33.034-73.784-73.783-73.784-40.75 0-73.784 33.034-73.784 73.784 0 40.749 33.034 73.784 73.784 73.784Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.126 31.031a73.79 73.79 0 0 0 122.945 78.091 73.785 73.785 0 0 1-77.614 44.138A73.787 73.787 0 0 1 23.126 31.031Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M77.812 80.313h.203L81.664 289.5H73.96l3.851-209.188Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "m66.45 175.186-1.7 3.228 12.197 6.421 1.7-3.228-12.197-6.421Zm260.122 115.149H-.572a.426.426 0 0 1-.428-.428.427.427 0 0 1 .428-.428h327.144a.428.428 0 0 1 0 .856Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M99.95 224.516H75.114a1.932 1.932 0 0 1-1.927-1.927v-10.705a14.343 14.343 0 0 1 24.488-10.143 14.345 14.345 0 0 1 4.202 10.143v10.705a1.933 1.933 0 0 1-1.927 1.927Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB8B8",
    d: "M123.565 237.962a4.012 4.012 0 0 0-3.306 3.608 4.002 4.002 0 0 0 .229 1.725l-6.754 6.211 2.774 5.025 9.414-8.906a4.035 4.035 0 0 0 2.225-4.878 4.039 4.039 0 0 0-4.582-2.785Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M103.241 266.201a10.795 10.795 0 0 1-9.608-5.844l-10.82-20.824a5.975 5.975 0 0 1 10.333-5.98l9.982 22.396 13.582-11.035 7.864 3.061-13.281 14.663a10.907 10.907 0 0 1-8.052 3.563Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "m143.268 234.025-12.033-12.034a2.244 2.244 0 0 0-3.175 0l-10.824 10.825a2.245 2.245 0 0 0 0 3.175l11.243 11.242c.4.401.938.636 1.505.656a2.24 2.24 0 0 0 1.549-.544l11.615-10.035a2.237 2.237 0 0 0 .771-1.535 2.228 2.228 0 0 0-.108-.869 2.227 2.227 0 0 0-.543-.881Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "m141.561 236.136-12.386-12.386-10.222 10.222 11.905 11.904 10.703-9.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "M130.053 239.739a5.03 5.03 0 1 0 0-10.06 5.03 5.03 0 0 0 0 10.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M132.295 238.998a5.03 5.03 0 0 0-5.123-8.407 5.044 5.044 0 0 1 4.091-.763 5.04 5.04 0 0 1 3.265 2.58 5.022 5.022 0 0 1-2.792 7.044c.197-.138.384-.29.559-.454Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M127.579 233.711c-.6.563-.632 2.592.284 3.567.916.974 2.432.526 3.032-.038.6-.563.056-1.029-.86-2.003-.916-.975-1.857-2.09-2.456-1.526Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M132.686 236.283a1.49 1.49 0 1 0 0-2.98 1.49 1.49 0 0 0 0 2.98Zm-2.68-2.851a1.49 1.49 0 1 0-.001-2.981 1.49 1.49 0 0 0 .001 2.981Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M132.685 235.165a.373.373 0 1 0 0-.746.373.373 0 0 0 0 .746Zm.165-1.105a.187.187 0 0 0 .187-.186.187.187 0 0 0-.373 0c0 .103.083.186.186.186Zm-2.679-2.85a.186.186 0 1 0 0-.372.187.187 0 0 0-.187.186c0 .103.084.186.187.186Zm-.166 1.103a.372.372 0 1 0 .002-.744.372.372 0 0 0-.002.744Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB8B8",
    d: "m183.979 286.867 2.273-4.732-17.171-11.018-3.354 6.985 18.252 8.765Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M195.117 274.924a6.59 6.59 0 0 0-5.035-.279 6.59 6.59 0 0 0-3.756 3.366l-1.533 3.19-2.363 4.924-.578 1.208 6.131 2.946 7.327-15.261-.193-.094Zm-12.009 2.432-.993 2.123-2.48 5.301-.06.133c-5.296.27-10.944-1.494-16.104-3.956a66.507 66.507 0 0 1-6.029-3.267 91.216 91.216 0 0 1-7.502-5.1c-3.075-2.325-4.955-4.038-4.955-4.038s-.565.437-1.584 1.182a164.057 164.057 0 0 1-6.294 4.367 167.119 167.119 0 0 1-3.375 2.184c-8.846 5.562-21.427 12.336-32.127 13.767-18.794 2.513-14.37-22.566-14.37-22.566l14.956-7.768 6.351 1.289 7.069 1.43 2.505.51s.475-.18 1.293-.493c2.634-1.006 8.821-3.383 14.165-5.506 2.753-1.097 5.28-2.129 6.98-2.869 6.02-2.634 12.76 3.746 12.76 3.746l29.794 19.531Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB8B8",
    d: "M59.864 290.65a4.013 4.013 0 0 0 3.114-3.774 4.015 4.015 0 0 0-.317-1.711l6.423-6.552-3.03-4.875-8.94 9.381a4.037 4.037 0 0 0 2.75 7.531Zm31.181-65.657c5.53 0 10.014-4.484 10.014-10.014 0-5.531-4.483-10.014-10.014-10.014-5.53 0-10.014 4.483-10.014 10.014 0 5.53 4.484 10.014 10.014 10.014Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "m78.016 242.777 8.723 24.731-.053.086c-1.213 2.006-1.61 3.624-1.146 4.679a2.036 2.036 0 0 0 1.292 1.115l20.643-14.429-.723-5.783.041-.065c1.995-3.192 2.641-6.083 1.92-8.593-.935-3.256-3.907-4.734-3.937-4.748l-.072-.057-10.296-12.531-13.763 2.445-2.63 13.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "m64.75 286.186-5.844-7.192 14.088-23.256 6.568-20.302a8.158 8.158 0 0 1 7.952-5.643 8.162 8.162 0 0 1 7.677 6.012 8.15 8.15 0 0 1-1.086 6.669L82.047 260.54 64.75 286.186Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M105.265 212.954H90.079l-.156-2.18-.779 2.18h-2.338l-.308-4.321-1.544 4.321H80.43v-.214a11.359 11.359 0 0 1 11.347-11.347h2.14a11.36 11.36 0 0 1 11.348 11.347v.214Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M89.953 226.513a1.95 1.95 0 0 1-.34-.03l-11.12-1.962v-18.378h12.24l-.303.353c-4.216 4.918-1.04 12.891 1.23 17.207a1.898 1.898 0 0 1-.152 2.015 1.92 1.92 0 0 1-1.555.795Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M250.838 194.375c26.96 0 48.815-21.855 48.815-48.814 0-26.96-21.855-48.815-48.815-48.815-26.96 0-48.815 21.855-48.815 48.815 0 26.959 21.855 48.814 48.815 48.814Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M238.361 126.587v41.532a1.075 1.075 0 0 0 .508.969 1.07 1.07 0 0 0 1.094.016l32.921-20.766c.161-.107.293-.253.385-.423a1.183 1.183 0 0 0 0-1.11 1.18 1.18 0 0 0-.385-.424l-32.921-20.766a1.057 1.057 0 0 0-1.482.417c-.09.171-.131.363-.12.555Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .53h327v296H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1 6.53h328v284.23H-1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioAndVideoCopy);
export default __webpack_public_path__ + "static/media/AudioAndVideoCopy.9659cc6b0402876cd91a8e9cf917ddf0.svg";
export { ForwardRef as ReactComponent };